<template>
    <div id="app" @click="handleTime">
        <router-view></router-view>
    </div>
</template>

<script>
import config from './config'
export default {
    name: "app",
    components: {},
    data() {
        return {
            timmer: null,
            lastTime: null
        };
    },
    created() {
        this.lastTime = new Date().getTime();
        
        window.addEventListener('resize', () => {
            this.handleTime();
        })
        
        window.addEventListener('scroll', () => {
            if (this.timmer) {
                clearTimeout(this.timmer);
            }
            
            this.timmer = setTimeout(() => {
                this.handleTime();
            }, 3000)
        }, true)
    },
    methods: {
        handleTime() {
            const curTime = new Date().getTime();
            if (curTime - this.lastTime > config.TIMEOUT) {
                //退出
                if (this.$route.path == '/login') {
                    return
                }
				this.$route.path == '/login'
                this.$alert('登录过期，请重新登录', '提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                        location.href = '/login'
                    }
                });
				// location.href = '/login'
            } else {
                this.lastTime = curTime;
            }
        }
    },
};
</script>

<style lang="less">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: @font-color;
  width: 100%;
  height: 100%;
  position: relative;
  
}
</style>
